module.exports = __webpack_public_path__ + "static/media/plus.908b5f4b.svg";